import { DEFAULTS } from "./defaults.js";
import { TABLE_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers.js";
const pluginTable = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: TABLE_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginTable
};
//# sourceMappingURL=viewer.js.map
